<template>
  <div>
    <vxe-grid
      auto-resize
      resizable
      border
      ref="table"
      size="small"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="400"
      :seq-config="{ startIndex: 0 }"
      :span-method="rowspanMethod"
    >
      <template v-slot:amzMarketName="{ row }">
        <div style="display: flex;justify-items: center;align-items: center;">
          <div style="flex: 1;">
            {{ row.amzMarketName }}
          </div>
          <div class="tag">
            <span
              class="animate-ping tag-sapn absolute"
              :style="{ backgroundColor: row.alertLevelColor }"
            ></span>
            <span
              class="tag-sapn relative"
              :style="{ backgroundColor: row.alertLevelColor }"
            ></span>
          </div>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'
import BaseTable from '@/mixins/base-table'

export default {
  mixins: [TableAutoHeight, BaseTable],
  props: {
    amzFlipOrderSkuCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      usePage: false,
      loading: false,
      format: (number) => format(number),
      tableColumns: tableColumns(this),
      editRules: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .ecomAmzFlipOrderMarketListApi({
          amzFlipOrderSkuCode: this.amzFlipOrderSkuCode,
        })
        .then((res) => {
          this.loading = false
          const tmpData = res?.body?.data || []
          for (let i = 0; i < tmpData.length; i++) {
            if (i == 0) {
              tmpData[i]['rowspan'] = tmpData.length
            } else {
              tmpData[i]['rowspan'] = 0
            }
          }
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    rowspanMethod({ row, column }) {
      const merger = ['ftyInv', 'ftyInvDaysAvailableLocal']
      if (!merger.includes(column.property)) {
        return { rowspan: 1, colspan: 1 }
      } else {
        return { rowspan: row.rowspan, colspan: 1 }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@keyframes ping {
  75%,
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1.5s cubic-bezier(0, 0, 0.1, 0.6) infinite;
}
.tag {
  position: relative;
  display: inline-flex;
  justify-content: center;
}
.tag-sapn {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  opacity: 0.75;
  display: inline-flex;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
</style>
